module.exports = __webpack_public_path__ + "static/media/coach-sarah2.761b883d.png";